  <div class="oi-main-dshd">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
        <div class="oi-comen-heading">
          <div class="row">
            <div class="col-md-4">
              <h2>History</h2>
            </div>
            <div class="col-md-3">
              <div class="search-hst-mn d-flex">
                <input type="text" [formControl]="searchControl" class="form-contro1" placeholder="Search...">
                <button type="button" class="search-hst-btn" (click)="onSearchButtonClick()">
                  <svg viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg>
                </button>
              </div>
            </div>
            <div class="col-md-2">
              <div class="oi-select-fld1 hstdrop">
                <p-dropdown [options]="availableFilter" [(ngModel)]="selectedSearchOption" optionLabel="searchFilter" optionValue="searchFilter" placeholder="Select a Search option" (onChange)="changeSearchOption($event)"></p-dropdown>
              </div>
        
            </div>
            <div class="col-md-3">
              <div class="oi-select-fld1 hstdrop">
                <p-dropdown [options]="availableCollections" [(ngModel)]="selectedCollection" optionLabel="collectionName" optionValue="collectionName" placeholder="Select a Collection" (onChange)="changeCollection($event)"></p-dropdown>
              </div>
        
            </div>
          </div>

        </div>
        </div>
      </div>

    


      
      <ng-container *ngIf="loader else showcontent">
        <div class="imgloader" *ngIf="loader">
          <img src="../../assets/img/loader.gif">
        </div>
      </ng-container>
      <ng-template #showcontent>
        <div class="row" *ngIf="saved_answers else noresult">
          <div class="col-md-12">
            <div class="oi-save-ans-bx-main chunk-parent" [ngClass]="{'aibt-qns-bx': savedanswer.answered_by?.toLowerCase() === 'bot','bot-qns-bx': savedanswer.answered_by === 'Canned'}"
              *ngFor="let savedanswer of saved_answers; let i=index " data-answer-type="saved-answers" [attr.data-question-index]="i">           
              <div class="oi-new-history-btn">  
               
                <div class="oi-eye-btn">
                  <button class="btn btn-primary" (click)="viewQuest(savedanswer)" pTooltip="view" tooltipPosition="top"><img src="../assets/img/eye.svg"></button>
                </div>

                 <div class="oi-verifiedbtn-new">
                  <button class="verfbtn" (click)="openAnsapprovemodal(savedanswer)" pTooltip="Answer approval" tooltipPosition="top"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1" /><path d="M9 12l2 2l4 -4" /></svg></button>
                </div>

                <div class="oi-gap-btn">
                  <button class="btn btn-primary"  (click)="knowledgegap(savedanswer.canned_question_id)" [pTooltip]="savedanswer.knowledge_gap ? 'Knowledge Gap':''"  tooltipPosition="bottom" tooltipStyleClass="custom-tooltip">
                    <img [src]="savedanswer.knowledge_gap ? '../assets/img/knowledge-gap-red.svg' : '../assets/img/knowledge-gap.svg'" 
                     [ngClass]="{'hover-gap-k': savedanswer.knowledge_gap}">
                 </button>
                </div>
              
                <div class="oi-tag-btn">
                  <div class="oi-bdge-1" *ngIf="savedanswer.answer_approved==1"><img src="../../assets/img/badge.png"></div>
                </div>
              </div>

  
              <div class="oi-qns-ans-box box">
                
                <div class="oi-sav-qns" [innerHTML]="sanitizeMessage(savedanswer.question,searchText)"></div>
                    <!-- Normal Text Answer -->
                    <div class="oi-sav-ans" *ngIf="!savedanswer.isBotMenu" [innerHTML]="sanitizeMessage(savedanswer.answer, searchText)">
                    </div>

                    <!-- Bot Menu Answer -->
                    <div class="oi-sav-ans" *ngIf="savedanswer.isBotMenu">
                      <p>{{ savedanswer.answer }}</p>
                      <div class="oi-gt-chat-tag">
                        <button
                          class="btn btn-tag"
                          *ngFor="let button of savedanswer.botMenu[0]?.buttons"
                        >
                          {{ button.title }}
                        </button>
                      </div>
                    </div>


                <div class="oi-tag-container">
                  <span *ngFor="let doc of savedanswer.documents_referred" class="tag" (click)="navigateToDoc(doc)">{{ doc?.document_name }}</span>
                </div>
                <div class="oi-history-date-n1">{{savedanswer.updated_at??savedanswer.created_at | customDate}}</div>
              </div>

              <div class="oi-genrate-tag-btn g-top" *ngIf="savedanswer.answered_by?.toLowerCase() === 'bot'"><img src="../assets/img/brain-icon.svg">AI Generated</div> 
              <div class="oi-genrate-tag-btn g-top" *ngIf="savedanswer.answered_by =='Canned'"><img src="../assets/img/power-icon.svg">Cached Response</div> 
               <div class="oi-exclamation-tag-btn g-top" *ngIf="savedanswer.answered_by== 'Canned'">Similarity {{ (savedanswer.confidence * 100) | number:'1.0-0' }}% </div> 
            </div>
          </div>
        </div>
        <div *ngIf="saved_answers?.length>0">
          <p-paginator (onPageChange)="onPageChange($event)"
            [first]="first" [rows]="rows" [totalRecords]="totalrecords"
            ></p-paginator>
        </div>
        <ng-template #noresult>
          <div class="oi-no-resultfound">
            <img src="../../assets/img/no-result.png">
            <h3>Sorry! No result found :(</h3>
            <p>We're sorry what you were looking for. Please try another way</p>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </div>
  <p-dialog [(visible)]="openmodalapprove" [header]="dialogTitle" [style]="{width: '55vw'}" [modal]="true"
  [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false"
  (onHide)="onDialogHideaddcollection()">
  <div class="oi-ad-collect-mdl khdoc">
    <ng-container *ngIf="searchloader; else showcontext">
      <div class="imgloader-new">
        <img src="../../assets/img/loader.gif">
      </div>
    </ng-container>
  
    <ng-template #showcontext>
      <div *ngIf="CannedQuestionList.length > 0; else noAnswers" class="modal-history-verified">
        <div class="mdl-verified-bx1" *ngFor="let doc of CannedQuestionList">
          <div class="mdl-ver-bx-inner">
          
            <div class="mdl-qns-ans-mn">
              <div class="mdl-ver-qns d-flex">
                <div class="qns-mn">{{ doc.question }}</div>
                <div class="slide-qns">
                  <div class="sav-toggle-mn">
                    <label class="switch">
                      <input type="checkbox" [(ngModel)]="doc.canned_answer_approved"
                        [checked]="doc.canned_answer_approved == 1" (change)="onToggleChange(doc)">
                      <span class="slider round"></span>
                    </label>
                  </div>                  
                </div>
                <div class="oi-modal-eye-btn">
                  <button class="btn btn-primary" (click)="viewQuest(doc.canned_question_id)" pTooltip="view" tooltipPosition="top"><img src="../assets/img/eye.svg"></button>
                </div>
              </div>
              <div class="mdl-ver-ans" [innerHTML]="sanitizeMessage(doc.canned_answer,'')"></div>
            </div>
          </div>
  
          <div class="mdl-verified-date">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
              <path d="M12 7v5l3 3" />
            </svg> {{ doc.canned_created_at | customDate }}
          </div>
        </div>
      </div>
  
      <!-- Message when CannedQuestionList is empty -->
      <ng-template #noAnswers>
        <div class="no-data-message">There are no similar answers available.</div>
      </ng-template>
    </ng-template>
  </div>
  
  

</p-dialog>
 

<p-dialog 
  header="Source Chunks" 
  [(visible)]="showChunkModal" 
  [modal]="true" 
  [dismissableMask]="true"
  [style]="{width: '30vw'}"
  [baseZIndex]="10000"
  [position]="'right'"
  class="chunk-oi">

  <div *ngFor="let chunk of selectedChunks" class="chunk-inner-bx1">
    <div class="chunk-mini-card"  [class.highlighted]="chunk.chunk_key.includes('[' + highlightedChunkId + ']')">
      <h4>{{ chunk.document_name }}</h4>
     <p [innerHTML]="sanitizedMessage(chunk.chunk_text)"></p>
     <div class="chunk-bottom-btn">
       <button type="button" class="btn chunk-outline-primary" (click)="navigatechunkToDoc(chunk)">
                        <svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" /><path d="M11 13l9 -9" /><path d="M15 4h5v5" /></svg> View Full Document
                    </button>
                    <button type="button" class="btn chunk-primary" (click)="copyChunkExcerpt(chunk.chunk_text)">
                        <svg   viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg> Copy Excerpt
                    </button>
     </div>
    </div>
  </div>

</p-dialog>